import React from "react";

/**
 * Genel amaçlı seçilebilir kart (radio-card).
 * Sihirbaz/adım seçimleri, tekli seçenek listeleri için kullanılır.
 * Atomic design: atom.
 *
 * @param {React.ComponentType} icon   İkon bileşeni (react-icons)
 * @param {string} title               Başlık
 * @param {string} [subtitle]          Açıklama satırı
 * @param {boolean} [selected]         Seçili mi
 * @param {boolean} [disabled]         Pasif mi
 * @param {Function} onClick           Tıklama
 */
export default function SelectableCard({
  icon: Icon,
  title,
  subtitle,
  selected = false,
  disabled = false,
  onClick,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      className={`group relative flex items-start gap-3 w-full text-left p-4 rounded-2xl border-2 transition-all duration-200 ${
        disabled
          ? "opacity-50 cursor-not-allowed border-gray-200 bg-gray-50"
          : selected
          ? "border-indigo-500 bg-indigo-50/60 shadow-sm"
          : "border-gray-200 bg-white hover:border-indigo-300 hover:bg-indigo-50/30"
      }`}
    >
      {Icon && (
        <span
          className={`flex items-center justify-center w-10 h-10 rounded-xl shrink-0 transition-colors ${
            selected
              ? "bg-indigo-500 text-white"
              : "bg-gray-100 text-gray-500 group-hover:bg-indigo-100 group-hover:text-indigo-600"
          }`}
        >
          <Icon className="w-5 h-5" />
        </span>
      )}
      <span className="flex flex-col min-w-0 pr-6">
        <span
          className={`font-semibold text-sm ${
            selected ? "text-indigo-700" : "text-gray-800"
          }`}
        >
          {title}
        </span>
        {subtitle && (
          <span className="text-xs text-gray-500 mt-0.5 leading-snug">
            {subtitle}
          </span>
        )}
      </span>
      <span
        className={`absolute top-3 right-3 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${
          selected ? "border-indigo-500 bg-indigo-500" : "border-gray-300 bg-white"
        }`}
      >
        {selected && (
          <svg
            className="w-3 h-3 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={3}
              d="M5 13l4 4L19 7"
            />
          </svg>
        )}
      </span>
    </button>
  );
}
